import Button from '@rezdy/components/Button';
import Grid from '@rezdy/components/Grid';
import Icon from '@rezdy/components/Icon';
import React from 'react';
import { TIdentityProvider } from '../services/auth';
// import TextStyle from '@rezdy/components/TextStyle';
import styled from 'styled-components';
import { WithTranslation, withTranslation } from 'react-i18next';
interface ISocialLoginProps extends WithTranslation {
    provider: TIdentityProvider;
    handleClick: (provider: TIdentityProvider) => void;
    name?: string;
}

const SocialButtonStyled = styled(Button)(({ theme }) => ({
    fontWeight: theme.weight.bold,
    fontFamily: theme.fontText,
    whiteSpace: 'nowrap',
}));

export class SocialLogin extends React.PureComponent<ISocialLoginProps> {
    handleClick = () => {
        const { provider, handleClick } = this.props;
        // redirect uri needs to be custom ui
        handleClick(provider);
    };

    render() {
        const { provider, name, i18n } = this.props;

        const socialLoginString = i18n.t('continueWith');

        return (
            <SocialButtonStyled
                onClick={this.handleClick}
                type="button"
                action="tertiary"
                width="100%"
                reversed
                tight
                name={name}
            >
                <Grid.Container cols="20px 1fr" colGap placeItems="center" style={{ height: '100%' }}>
                    <Grid.Cell style={{ display: 'inline-block' }}>
                        {provider === 'Google' && <Icon name="google" size="large" />}
                    </Grid.Cell>
                    <Grid.Cell style={{ display: 'inline-block' }}>
                        <>{`${socialLoginString}${provider}`}</>
                    </Grid.Cell>
                </Grid.Container>
            </SocialButtonStyled>
        );
    }
}

export default withTranslation()(SocialLogin);
